<template>
</template>

<script>
export default {
    data: function () {
        return {
            scrollToAnchor: '#',
        }
    },
    props: [
    ],
    mounted() {
    },
    methods: {

        /**
         * scroll to anchor
         *
         * @return  {void}
         */
        scrollTo(anchor) {

            // Scroll to top of section
            $('html, body').animate({
               scrollTop: $(anchor).offset().top
            }, 1000);
        },
    },
}
</script>
